import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
	EnvironmentProviders,
	importProvidersFrom,
	Injector,
	Provider,
	inject,
	provideAppInitializer,
} from '@angular/core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import { environment } from 'projects/admin/src/environments/environment';
import { ApplicationInitializerFactory } from 'shared/configs/translation.config';
import { LocaleInterceptor } from 'shared/interceptors/locale.interceptor';
import { VersionCheckerInterceptor } from 'shared/interceptors/version-checker-interceptor.service';
import { MaterialModule } from 'shared/modules/material/material.module';
import { TableTranslateService } from 'shared/modules/table-translate/table-translate.service';
import { ApiModule } from 'shared/openapi/api.module';
import { LoggerService } from 'shared/services/logger.service';
import { PageTitleStrategy } from 'shared/services/page-title-strategy.service';
import { WINDOW_PROVIDERS } from 'shared/tools/window-provider';

const MY_FORMATS = {
	parse: {
		dateInput: 'YYYY MM DD',
	},
	display: {
		dateInput: 'YYYY.MM.DD.',
		monthYearLabel: 'YYYY.MM.',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'YYYY.MM.',
	},
};

export const sharedProviders: Array<Provider | EnvironmentProviders> = [
	[{ provide: TitleStrategy, useClass: PageTitleStrategy }],
	provideHttpClient(withInterceptorsFromDi()),
	provideEnvironmentNgxMask(),
	provideAnimations(),
	importProvidersFrom(MaterialModule),
	{
		provide: HTTP_INTERCEPTORS,
		useClass: VersionCheckerInterceptor,
		multi: true,
	},
	{
		provide: HTTP_INTERCEPTORS,
		useClass: LocaleInterceptor,
		multi: true,
	},
	provideAppInitializer(() => {
		const initializerFn = ApplicationInitializerFactory(
			inject(TranslateService),
			inject(Injector),
			inject(LoggerService)
		);
		return initializerFn();
	}),
	{
		provide: MatPaginatorIntl,
		useClass: TableTranslateService,
	},
	{
		provide: MAT_DATE_FORMATS,
		useValue: MY_FORMATS,
	},
	{
		provide: MAT_DATE_LOCALE,
		useValue: 'hu-HU',
	},
	WINDOW_PROVIDERS,
	importProvidersFrom(
		ApiModule.forRoot({
			rootUrl: (window.location.origin + environment.base_href).endsWith('/')
				? (window.location.origin + environment.base_href).slice(0, -1)
				: window.location.origin + environment.base_href,
		}),
		MaterialModule
	),
];
